// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { merlin as _merlin } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the merlin chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 4200
 * Chain Name: Merlin
 * Default Block Explorer: https://scan.merlinchain.io
 * Default RPC URL: https://rpc.merlinchain.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { merlin } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: merlin,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const merlin = createCommon({
	..._merlin,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
